import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAEVV3NB1xA6WvYi8PpUB1z9B_DDbayR5I",
  authDomain: "jbcentreprenoeren.firebaseapp.com",
  projectId: "jbcentreprenoeren",
  storageBucket: "jbcentreprenoeren.appspot.com",
  messagingSenderId: "325019690809",
  appId: "1:325019690809:web:ba7c3ea15b349a18e7eae8",
  measurementId: "G-SZ7GHFZT3X"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };